import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import GameStatusBar from 'components/GameStatusBar'

import { MatchEventType, MatchStatus, IPlayer, IMatch, IMatchEvent } from 'protos'

const players = {
  'player:gera': { name: 'Gera' },
  'player:kiraly': { name: 'Király' },
  'player:cr7': { name: 'Ronaldo' },
}

const event1: IMatchEvent = {
  eventId: '1',
  elapsedMin: 5,
  playerId: 'player:gera',
  type: MatchEventType.ET_SHOT_ON_GOAL,
  displayValue: 20,
}

const event2: IMatchEvent = {
  eventId: '2',
  elapsedMin: 0,
  playerId: 'player:gera',
  type: MatchEventType.ET_GOAL,
  displayValue: 50,
}

const event3: IMatchEvent = {
  eventId: '3',
  elapsedMin: 0,
  playerId: 'player:cr7',
  type: MatchEventType.ET_SHOT_ON_GOAL,
  displayValue: 0,
}

const event4: IMatchEvent = {
  eventId: '4',
  elapsedMin: 0,
  playerId: 'player:kiraly',
  type: MatchEventType.ET_SAVE,
  displayValue: 20,
}

const event5: IMatchEvent = {
  eventId: '5',
  elapsedMin: 0,
  teamId: 'team:hu',
  type: MatchEventType.ET_CORNER,
  displayValue: 2,
}

const upcomingMatch: IMatch = {
  status: MatchStatus.MS_UPCOMING,
}

const liveMatch: IMatch = {
  status: MatchStatus.MS_LIVE,
  homeTeam: {
    teamId: 'team:hu',
    name: 'Hungary',
  },
  awayTeam: {
    teamId: 'team:pt',
    name: 'Portugal',
  },
}

const finishedMatch: IMatch = {
  status: MatchStatus.MS_FINISHED,
}

const cancelledMatch: IMatch = {
  status: MatchStatus.MS_CANCELLED,
}

type Props = {
  match: IMatch
  players: { [k: string]: IPlayer }
  onClick?: () => void
}

type State = {
  events: Array<IMatchEvent>
}

class GameStatusBarWithEvents extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      events: [event1],
    }
  }

  componentDidMount() {
    setTimeout(() => this.setState({ events: [event1, event2] }), 2000)
    setTimeout(() => this.setState({ events: [event1, event2, event3, event4] }), 5000)
    setTimeout(() => this.setState({ events: [{ ...event4, elapsedMin: 2 }] }), 12000)
    setTimeout(() => this.setState({ events: [event5] }), 15000)
  }

  render() {
    return <GameStatusBar {...this.props} events={this.state.events} />
  }
}

storiesOf('GameStatusBar', module)
  .add('upcoming', () => (
    <GameStatusBar match={upcomingMatch} events={[]} players={players} onClick={action('GameStatusBar clicked.')} />
  ))
  .add('live', () => (
    <GameStatusBarWithEvents match={liveMatch} players={players} onClick={action('GameStatusBar clicked.')} />
  ))
  .add('finished', () => (
    <GameStatusBar match={finishedMatch} events={[]} players={players} onClick={action('GameStatusBar clicked.')} />
  ))
  .add('cancelled', () => (
    <GameStatusBar match={cancelledMatch} events={[]} players={players} onClick={action('GameStatusBar clicked.')} />
  ))
